// TODO: Remove this file after migration to openapi-fetch

import { ROUTES } from "@/constants/routes";
import { tokenStorage } from "@/lib/storage/token";

import { refreshIfNeeded } from "./utils";

export async function apiFetch(
  url: string,
  options: RequestInit = {},
  retry = true,
): Promise<Response> {
  const token = tokenStorage.getToken();
  const hasFormDataBody = options.body instanceof FormData;
  const headers: Record<string, string> = {
    ...(hasFormDataBody ? {} : { "Content-Type": "application/json" }),
    ...((options.headers as Record<string, string>) || {}),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const resp = await fetch(url, { ...options, headers });

  if (resp.status === 401 && retry) {
    const refreshed = await refreshIfNeeded();
    if (refreshed) {
      // Retry with new token
      return apiFetch(url, options, false);
    }
    // Refresh failed — redirect to login
    tokenStorage.clear();
    window.location.href = ROUTES.LOGIN;
  }

  return resp;
}
